import axios from '@/services/axios'

export type PlatformPackage = {
	id: number
	title: string
	price: number
	provision: number
	duration: number
}

export type PlatformExtra = {
	id: number
	title: string
	price: number
}

export type PlatformPackages = {
	packages: PlatformPackage[]
	extras: PlatformExtra[]
}

const getPackages = async (): Promise<PlatformPackages> => {
	const response = await axios.get('/platform/packages')
	return response.data.data
}

const updatePackages = async (data: PlatformPackages): Promise<PlatformPackages> => {
	const response = await axios.put('/platform/packages', data)
	return response.data.data
}

const listCategories = async () => {
	const response = await axios.get('/category/get/all?limit=200&page=1')
	return response.data.data as Array<{ id: number; name: string; status?: string; description?: string }>
}

const createCategory = async (data: { name: string; status?: string; description?: string }) => {
	const response = await axios.post('/category', data)
	return response.data.data
}

const updateCategory = async (
	id: number,
	data: { name: string; status?: string; description?: string },
) => {
	const response = await axios.put(`/category/${id}`, data)
	return response.data.data
}

const deleteCategory = async (id: number) => {
	const response = await axios.delete(`/category/${id}`)
	return response.data
}

const listTypes = async () => {
	const response = await axios.get('/type/get/all?limit=200&page=1')
	return response.data.data as Array<{ id: number; name: string; status?: string; description?: string }>
}

const createType = async (data: { name: string; status?: string; description?: string }) => {
	const response = await axios.post('/type', data)
	return response.data.data
}

const updateType = async (
	id: number,
	data: { name: string; status?: string; description?: string },
) => {
	const response = await axios.put(`/type/${id}`, data)
	return response.data.data
}

const deleteType = async (id: number) => {
	const response = await axios.delete(`/type/${id}`)
	return response.data
}

const platformService = {
	getPackages,
	updatePackages,
	listCategories,
	createCategory,
	updateCategory,
	deleteCategory,
	listTypes,
	createType,
	updateType,
	deleteType,
}

export default platformService
